<template>
  <v-card>
    
    <div class="d-flex py-4 px-12">
      <h4 class="secondary--text font-weight-bold">
        {{ 'Configuración de informe' }}
      </h4>
    </div>
    <v-divider></v-divider>
    <v-form ref="form" v-model="valid" >

      <v-container class="py-10" v-if="loading">
        <v-progress-linear
          indeterminate
          color="blue"
          class="mb-0"
          width="100%"
        />

        <v-layout row wrap justify-center mt-5> <h3>Cargando..</h3> </v-layout>
      </v-container>

      <v-container class="py-10" v-if="serviceNotFound">
        <v-layout row wrap justify-center>
          <h3>Servicio no disponible</h3>
        </v-layout>
      </v-container>

      <v-container
        cols="12"
        sm="12"
        md="12"
        lg="12"
        xl="12"
        v-if="!serviceNotFound && !loading"
        class=""
      >
        <v-col cols="12" class="d-flex justify-space-between">
          <h4 class="textColor">
            {{ $t('Datos de la Configuración del informe ') }}
          </h4>

          <h4 class="camposObligatorios">
            {{ $t('*Campos obligatorios') }}
          </h4>
        </v-col>
        <v-row>
          <v-col md="10">
            <v-row
              :key="index"
              v-for="(condition, index) in conditionsSelected"
            >
              <v-col cols="5">
                <!-- dropdown-->
                <!-- conditionsAvailables array con las condiciones-->

                <v-select
                  :label="'Tipo *'"
                  required
                  v-model="conditionSelected"
                  :rules="firstConditionRules"
                  return-object
                  :items="availableReportList"
                  item-text="name"
                  hide-details="auto"
                  :ref="`select-${index}`"
                  filled
                  dense
                  @change="
                    val => {
                      onSelectReportType(val, index)
                    }
                  "
                  color="tertiary"
                  :disabled="!isFormReady"
                >
                  <template v-slot:label>
                    <span v-if="conditionSelected" class="label">Tipo </span>
                    <span v-else>Tipo </span>
                    <span class="asterisc"> *</span>
                  </template>
                </v-select>
              </v-col>
              <!-- v-col
                cols="5"
                v-if="conditionSelected == 'Velocidad por tipo de vía'"
                m
              >
                <v-select
                  :label="'tipo'"
                  required
                  v-model="typeOfReportVelPorTipoVia"
                  :rules="firstConditionRules"
                  return-object
                  :items="typeOfReportListVia"
                  item-text="name"
                  hide-details="auto"
                  :ref="`select-${index}`"
                  filled
                  dense
                  color="tertiary"
                >
                  <template v-slot:label>
                    <span v-if="conditionSelected" class="label"
                      >Condición
                    </span>
                    <span v-else>Tipo </span>
                  </template>
                </v-select>
              </v-col -->

              <v-col cols="5" v-if="conditionSelected == 'Informe de viajes'" m>
                <v-select
                  :label="'Inicio de viaje'"
                  required
                  v-model="startTripSelected"
                  :rules="firstConditionRules"
                  return-object
                  :items="startTripList"
                  item-text="name"
                  hide-details="auto"
                  :ref="`select-${index}`"
                  filled
                  dense
                  color="tertiary"
                >
                  <template v-slot:label>
                    <span v-if="startTripSelected" class="label"
                      >Inicio de viaje
                    </span>
                    <span v-else>Inicio de viaje </span>
                    <span class="asterisc"> *</span>
                  </template>
                </v-select>
              </v-col>
              <v-col
                cols="5"
                v-if="
                  (startTripSelected == startTripList[0]) &
                    (conditionSelected == 'Informe de viajes')
                "
                m
              >
                <v-text-field
                  filled
                  v-model="starTingtimeLapseMoving"
                  label="Tiempo minimo en movimiento (minutos):"
                  dense
                  required
                  hide-details="auto"
                  :error-messages="errorName"
                  :rules="zoneRules"
                  color="tertiary"
                >
                  <template v-slot:label>
                    <span>Tiempo minimo en movimiento (minutos):</span>
                    <span class="asterisc"> *</span>
                  </template></v-text-field
                >
              </v-col>

              <v-col
                cols="5"
                v-if="
                  startTripSelected == startTripList[1] &&
                    conditionSelected == 'Informe de viajes'
                "
                m
              >
                <v-text-field
                  filled
                  v-model="minKm"
                  :label="'Kms mínimos recorridos sin paradas:'"
                  dense
                  required
                  hide-details="auto"
                  :error-messages="errorName"
                  :rules="[...integerRules, ...kmsRules]"
                  color="tertiary"
                >
                  <template v-slot:label>
                    <span v-if="minKm" class="blue--text"
                      >Kms mínimos recorridos sin paradas:</span
                    >
                    <span v-else>Kms mínimos recorridos sin paradas:</span>
                    <span class="asterisc"> *</span>
                  </template></v-text-field
                >
              </v-col>

              <v-col cols="5" v-if="conditionSelected == 'Informe de viajes'" m>
                <v-text-field
                  filled
                  v-model="stopTimeLapseMoving"
                  :label="'Parada máxima (minutos):'"
                  dense
                  required
                  hide-details="auto"
                  :error-messages="errorName"
                  :rules="zoneRules"
                  color="tertiary"
                >
                  <template v-slot:label>
                    <span v-if="stopTimeLapseMoving" class="blue--text"
                      >Parada máxima (minutos):</span
                    >
                    <span v-else>Parada máxima (minutos):</span>
                    <span class="asterisc"> *</span>
                  </template></v-text-field
                >
              </v-col>

              <v-col
                cols="5"
                v-if="conditionSelected == 'Informe de control de zonas'"
                m
              >
                <v-select
                  :label="'Tolerancia'"
                  required
                  v-model="typeOfZones"
                  :rules="firstConditionRules"
                  return-object
                  :items="typeOfZonesList"
                  item-text="name"
                  hide-details="auto"
                  :ref="`select-${index}`"
                  filled
                  dense
                  color="tertiary"
                >
                  <template v-slot:label>
                    <span v-if="conditionSelected" class="label">Condición</span>
                    <span class="asterisc"> *</span>
                  </template>
                </v-select>
              </v-col>

              <v-col
                cols="5"
                v-if="
                  conditionSelected ==
                    'Consumo de combustible por kilómetros recorridos'
                "
                m
              >
                <v-select
                  :label="'Tolerancia'"
                  required
                  v-model="typeOfReportConsumoCombustible"
                  :rules="firstConditionRules"
                  return-object
                  :items="typeOfReportList"
                  item-text="name"
                  hide-details="auto"
                  :ref="`select-${index}`"
                  filled
                  dense
                  color="tertiary"
                >
                  <template v-slot:label>
                    <span class="label">Condición</span>
                    <span class="asterisc"> *</span>
                  </template>
                </v-select>
              </v-col>

              <v-col
                cols="5"
                v-if="
                  allAndInsideZone &&
                    conditionSelected == 'Informe de control de zonas'
                "
              >
                <v-text-field
                  filled
                  v-model="insideZone"
                  :label="'Tiempo de tolerancia dentro de zona'"
                  dense
                  required
                  hide-details="auto"
                  :error-messages="errorName"
                  :rules="zoneRules"
                  color="tertiary"
                >
                  <template v-slot:label>
                    <span v-if="insideZone" class="blue--text"
                      >Tiempo de tolerancia dentro de zona (minutos)</span
                    >
                    <span v-else>Tiempo de tolerancia dentro de zona (minutos)</span>

                    <span class="asterisc"> *</span>
                  </template></v-text-field
                >
              </v-col>

              <v-col
                cols="5"
                v-if="
                  allAndOutsideZone &&
                    conditionSelected == 'Informe de control de zonas'
                "
              >
                <v-text-field
                  filled
                  v-model="outsideZone"
                  :label="'Tolerancia fuera de zona'"
                  dense
                  required
                  hide-details="auto"
                  :error-messages="errorName"
                  :rules="zoneRules"
                  color="tertiary"
                >
                  <template v-slot:label>
                    <span v-if="outsideZone" class="blue--text"
                      >Tiempo de tolerancia fuera de zona (minutos)</span
                    >
                    <span v-else>Tiempo de tolerancia fuera de zona (minutos)</span>

                    <span class="asterisc"> *</span>
                  </template></v-text-field
                >
              </v-col>

              <v-col
                cols="5"
                class="mt-n2"
                v-if="
                  (allAndOutsideZone || allAndInsideZone) &&
                    conditionSelected == 'Informe de control de zonas'
                "
              >
                <div
                  @geofenceEmit="
                    geofences => {
                      geofenceEmit(geofences, index)
                    }
                  "
                  is="GeofenceAgent"
                  editMode
                ></div>
              </v-col>

              <v-col cols="4" v-if="conditionSelected == 'Detenciones'" m>
                <v-text-field
                  filled
                  v-model="detentionTime"
                  label="Tiempo mínimo de detención:"
                  dense
                  required
                  hide-details="auto"
                  :error-messages="errorName"
                  :rules="[...detentionTimeRules, ...integerRules]"
                  color="tertiary"
                >
                  <template v-slot:label>
                    <span v-if="detentionTime" class="blue--text"
                      >Tiempo mínimo de detención (minutos):</span
                    >
                    <span v-else>Tiempo mínimo de detención (minutos)</span>

                    <span class="asterisc"> *</span>
                  </template></v-text-field
                >
              </v-col>

              <v-col
                cols="3"
                v-if="conditionSelected == 'Exceso de velocidad'"
                m
              >
                <v-text-field
                  filled
                  v-model="speedLimit"
                  :label="'Tope Km/h'"
                  dense
                  required
                  hide-details="auto"
                  :error-messages="errorName"
                  :rules="speedRules"
                  color="tertiary"
                >
                  <template v-slot:label>
                    <span v-if="speedLimit" class="blue--text">Tope Km/h</span>
                    <span v-else>Tope Km/h</span>
                    <span class="asterisc"> *</span>
                  </template></v-text-field
                >
              </v-col>
              <v-col v-if="index > 0" class="align-self-center text-right">
                <v-btn
                  color="secondary"
                  icon
                  x-small
                  @click="removeCondition(index)"
                >
                  <v-icon> mdi-trash-can-outline </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col md="2" class="align-self-center">
            <v-btn
              v-if="
                conditionsSelected.length < amountConditions &&
                  isCombinable &&
                  conditionsSelected[0].agent !== ''
              "
              small
              color="tertiary"
              text
              @click="addCondition()"
            >
              <span class="text-capitalize text-body-2">{{
                $t(
                  'fleet_management.agents.create.labels.create_agent_add_condition'
                )
              }}</span>
              <v-icon right> mdi-plus </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="mt-3">
          <v-col md="7">
            <v-row>
              <v-col cols="7">
                <v-text-field
                  filled
                  :label="'Nombre'"
                  dense
                  :value="customNameFormat"
                  required
                  counter="50"
                  hide-details="auto"
                  :error-messages="errorName"
                  @change="val => onChangeName(val)"
                  :rules="nameRules"
                  color="tertiary"
                >
                  <template v-slot:label>
                    <span v-if="customNameFormat" class="blue--text"
                      >Nombre</span
                    >
                    <span v-else>Nombre</span>
                    <span class="asterisc"> *</span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        

        <v-row class="mt-n6">
          <v-col>
            <hr class="divider-dotted" />
          </v-col>
          <v-col class="mt-n3" cols="12">
            <h4 class="secondary--text">
              {{
                $t(
                  'fleet_management.agents.create.labels.create_agent_form_things_title'
                )
              }}
              <span class="asterisc">*</span>
            </h4>
          </v-col>
        </v-row>

        <!-- entidades NUEVA -->

        <v-row class="mt-2">
          <v-col md="7">
            <v-row>
              <BaseFilter :tags="filteredTags" :things="filteredThings" @updateThingsApplied="setThingsApplied" @updateIsFilterApplied="setIsFilterApplied"/>
            </v-row>
          </v-col>
        </v-row>
        
        <!-- RPM minimos -->
        <v-row
          class="mt-2"
          v-if="
            conditionSelected ==
              'Consumo de combustible por kilómetros recorridos'
          "
        >
          <v-col cols="7">
            <v-row>
              <v-col cols="5">
                <v-text-field
                  filled
                  :label="'RPM Mínima'"
                  :error-messages="errorName"
                  @change="onChangeNumber"
                  :rules="integerRules"
                  :value="rpmMinima"
                  color="tertiary"
                  type="number"
                  step="1"
                >
                  <template v-slot:label>
                    <span v-if="customRPM" class="blue--text">RPM Mínima</span>
                    <span v-else>RPM Mínima</span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-col class="mt-n5">
          <hr class="divider-dotted" />
        </v-col>

        <v-row class="mt-n5" v-if="hasScheduledReportRole">
          <v-col cols="4" md="3" offset-md="0">
            <v-select
              filled
              v-model="selectedGenerateArray"
              :items="generateArray"
              color="tertiary"
            >
              <template v-slot:label>
                <span v-if="selectedGenerateArray" class="blue--text"
                  >Generación de informe</span
                >
                <span v-else>Generación de informe</span>
              </template>
            </v-select>
          </v-col>
        </v-row>
        <v-row
          v-if="
            conditionSelected == 'Móviles que no reportan' &&
              selectedGenerateArray != 'Programar'
          "
          class="mt-n5 mb-0"
        >
          <v-col class="ml-n3" md="3" offset-md="0">
            <v-col cols="10">
              <v-select
                dense
                required
                v-model="selectedDateRange"
                :items="ThingsdateRangeArray"
                item-text="text"
                item-value="value"
                :label="`${dateRange} *`"
                color="tertiary"
                item-color="tertiary"
                @change="setTimeRequest"
                return-object
                hide-details
                class="mr-4 tertiary--text align-center"
              >
                <template v-slot:prepend>
                  <v-icon color="#0083FF">
                    mdi-calendar-clock-outline
                  </v-icon></template
                >

                <template v-slot:label>
                  <span v-if="selectedDateRange" class="blue--text"
                    >No reportan Desde hace
                  </span>
                  <span v-else>No reportan Desde</span>
                </template>
              </v-select>
            </v-col>
            <!--<v-col cols="12">
              <v-checkbox
                @click="selectedEmail"
                v-model="selectedNotificationEmail"
                color="tertiary"
                label="Notificarme via email"
              ></v-checkbox>
            </v-col>-->
          </v-col>

          <!--fecha Móviles que no reportan ">  -->
          <!-- <v-col
            v-if="selectedDateRange == 'Personalizado'"
            class="ml-n15"
            md="3"
            offset-md="0"
          >
            <v-col cols="10">
              <v-menu
                v-model="fromDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    readonly
                    :value="fromDateDisp"
                    v-on="on"
                    :rules="dateStartRules"
                    dense
                    prepend-icon="mdi-calendar"
                    @change="setTimeRequest"
                    hide-details="auto"
                    class="mr-4 align-center"
                    color="tertiary"
                    :error-messages="errorMessage"
                  >
                    <template v-slot:prepend>
                      <v-icon color="#0083FF">
                        mdi-calendar-month-outline
                      </v-icon></template
                    >

                    <template v-slot:label>
                      <span v-if="selectedDateRange" class="blue--text"
                        >Fecha
                      </span>
                      <span v-else>Fecha</span>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  locale="es-AR"
                  :max="endDateValue"
                  v-model="fromDateVal"
                  no-title
                  @input="fromDateMenu = false"
                  color="tertiary"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-col>-->

          <!-- time-->
          <v-col
            v-if="selectedDateRange == 'Personalizado'"
            class="ml-n15"
            md="3"
            offset-md="0"
          >
            <v-col cols="12">
              <v-menu
                ref="menuTimeStart"
                v-model="menuTimeStart"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="startTime"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    dense
                    v-model="startTime"
                    @change="setTimeRequest"
                    readonly
                    :disabled="pickerDisabled"
                    v-bind="attrs"
                    hide-details="auto"
                    :rules="timeRules"
                    :error-messages="errorMessage"
                    color="tertiary"
                    v-on="on"
                    class="mr-4 align-center"
                    
                  >
                    <template v-slot:prepend>
                      <v-icon color="#0083FF"> mdi-alarm </v-icon></template
                    >

                    <template v-slot:label>
                      <span v-if="startTime" class="blue--text">Hora </span>
                      <span v-else>Hora </span>
                    </template>
                  </v-text-field>
                </template>
                <v-time-picker
                  v-if="menuTimeStart"
                  v-model="startTime"
                  color="tertiary"
                  no-title
                  @click:minute="$refs.menuTimeStart.save(startTime)"
                ></v-time-picker>
              </v-menu>
            </v-col>
          </v-col>
        </v-row>

        <v-row v-else class="mt-n9 mb-0">
          <v-col md="11" sm="11" xs="11" class="ml-9">
            <ProgramReport
              :sendSelectedTimesPeriods="getSelectedTimesPeriods"
              v-if="selectedGenerateArray == 'Programar'"
            />
          </v-col>
          <v-col
            cols="12"
            v-if="selectedGenerateArray == 'Programar'"
            class="mt-2"
            md="11"
          >
            <h4 class="textColor">Vigencia del informe prorgramado</h4>
          </v-col>

          <!--range date-->

          <v-col
            v-if="selectedGenerateArray == 'Generar Ahora'"
            :class="screenSize ? 'align-date' : 'ml-n3'"
            md="3"
          >
            <v-col cols="12">
              <v-select
                dense
                required
                v-model="selectedDateRange"
                :items="dateRangeArray"
                item-text="text"
                item-value="value"
                :label="dateRange"
                color="tertiary"
                item-color="tertiary"
                @change="setTimeRequest"
                return-object
                hide-details
                class="mr-4 ml-n18 tertiary--text align-center"
              >
                <template v-slot:prepend>
                  <v-icon
                    color="#0083FF
           "
                  >
                    mdi-calendar-clock-outline
                  </v-icon></template
                >
                <template v-slot:label>
                  <span v-if="selectedDateRange" class="blue--text"
                    >Rango de fecha *
                  </span>
                  <span v-else>Rango de fecha</span>
                  <span class="asterisc"> *</span>
                </template>
              </v-select>
            </v-col>
            <!--<v-col cols="12">
              <v-checkbox
                @click="selectedEmail"
                v-model="selectedNotificationEmail"
                color="tertiary"
                label="Notificarme via email"
              ></v-checkbox>
            </v-col>-->
          </v-col>

          <!--start date-->

          <v-col
            v-if="
              selectedDateRange == 'Personalizado' ||
                selectedGenerateArray == 'Programar'
            "
            :class="
              selectedGenerateArray == 'Programar' || screenSize ? '' : 'ml-n15'
            "
            md="3"
            offset-md="0"
            :cols="screenSize ? '10' : '2'"
          >
            <v-col cols="12">
              <v-menu
                v-model="fromDateMenu"
                :close-on-content-click="false"
                :nudge-right="120"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    readonly
                    :value="fromDateDisp"
                    v-on="on"
                    :rules="dateStartRules"
                    @change="setTimeRequest"
                    dense
                    prepend-icon="mdi-calendar"
                    hide-details="auto"
                    class="mr-4 align-center"
                    color="tertiary"
                    :error-messages="errorMessageDateFrom"
                  >
                    <template v-slot:prepend>
                      <v-icon color="#0083FF">
                        mdi-calendar-month-outline
                      </v-icon></template
                    >

                    <template v-slot:label>
                      <span v-if="selectedDateRange" class="blue--text"
                        >Fecha de Inicio
                      </span>
                      <span v-else>Fecha de Inicio</span>
                      <span class="asterisc"> *</span>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  locale="es-AR"
                  :max="selectedGenerateArray != 'Programar' ? endDateValue : ''"
                  v-model="fromDateVal"
                  no-title
                  @input="fromDateMenu = false"
                  @change="setTimeRequest"
                  color="tertiary"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-col>

          <!--start time-->

          <v-col 
            :class="screenSize ? ' ' : 'ml-n15'"
            :cols="screenSize ? '10' : '2'"
            md="2"
            offset-md="0"
            v-if="
              selectedDateRange == 'Personalizado' &&
                selectedGenerateArray == 'Generar Ahora'
            "
          >
            <v-row class="mx-0 my-0 px-3 py-3">
              <v-col cols="auto" class="mx-0 px-0 py-0">
                <v-menu
                  ref="menuTimeStart"
                  v-model="menuTimeStart"
                  :close-on-content-click="false"
                  :nudge-right="110"
                  transition="scale-transition"
                  offset-y
                  content-class="margin-left-84"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      class="mx-0"
                      :disabled="disableBtnStartTime"
                    >
                      <v-icon color="#0083FF">mdi-clock-time-four-outline</v-icon>
                    </v-btn>
                  </template>
                  <v-time-picker
                    v-if="menuTimeStart"
                    v-model="startTime"
                    color="tertiary"
                    no-title
                    @click:minute="$refs.menuTimeStart.save(startTime)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
              <v-col class="mx-0 px-0 py-0">
                <v-text-field
                  dense
                  v-model="startTime"
                  @change="setTimeRequest"
                  :disabled="pickerDisabled"
                  hide-details="auto"
                  :rules="rulesTime"
                  :error-messages="errorMessage"
                  color="tertiary"
                  class="mr-4 align-center fix-input-align"
                  @input="checkTimeDifference('startTime')"
                >
                    <template v-slot:label>
                      <span v-if="startTime" class="blue--text"
                        >Hora de inicio
                      </span>
                      <span v-else>Hora de inicio</span>
                      <span class="asterisc"> *</span>
                    </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <!--end date-->

          <v-col
            v-if="
              selectedDateRange == 'Personalizado' ||
                selectedGenerateArray == 'Programar'
            "
            :cols="screenSize ? '10' : '2'"
            :class="
              selectedGenerateArray == 'Programar' || screenSize
                ? ''
                : 'ml-n10'
            "
            md="3"
            offset-md="0"
          >
            <v-col cols="12">
              <v-menu
                v-model="fromDateMenuEnd"
                :close-on-content-click="false"
                :nudge-right="120"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    readonly
                    :value="fromDateDispEnd"
                    v-on="on"
                    dense
                    prepend-icon="mdi-calendar"
                    @change="setTimeRequest"
                    hide-details="auto"
                    class="mr-4 align-center"
                    color="tertiary"
                    :error-messages="errorMessageDateTo"
                  >
                    <template v-slot:prepend>
                      <v-icon color="#0083FF">
                        mdi-calendar-month-outline
                      </v-icon></template
                    >

                    <template v-slot:label>
                      <span v-if="selectedDateRange" class="blue--text"
                        >Fecha de Fin
                      </span>
                      <span v-else>Fecha de Fin</span>
                      <span class="asterisc"> *</span>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  locale="es-AR"
                  :min="selectedGenerateArray != 'Programar' ? initDateValue : ''"
                  :max="selectedGenerateArray != 'Programar' ? maxDate : ''"
                  @change="setTimeRequest"
                  v-model="fromDateValEnd"
                  no-title
                  @input="fromDateMenuEnd = false"
                  color="tertiary"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-col>

          <!--end time-->

          <v-col 
            :class="screenSize ? ' ' : 'ml-n15'"
            :cols="screenSize ? '10' : '2'"
            md="2"
            offset-md="0"
            v-if="
              selectedDateRange == 'Personalizado' &&
                selectedGenerateArray == 'Generar Ahora'
            "
          >
            <v-row class="mx-0 my-0 px-3 py-3">
              <v-col cols="auto" class="mx-0 px-0 py-0">
                <v-menu
                  ref="menuTimeEnd"
                  v-model="menuTimeEnd"
                  :close-on-content-click="false"
                  :nudge-right="110"
                  transition="scale-transition"
                  offset-y
                  content-class="margin-left-84"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      class="mx-0"
                      :disabled="disableBtnStartTime"
                    >
                      <v-icon color="#0083FF">mdi-clock-time-four-outline</v-icon>
                    </v-btn>
                  </template>
                  <v-time-picker
                    v-if="menuTimeEnd"
                    @change="setTimeRequest"
                    v-model="endTime"
                    color="tertiary"
                    no-title
                    @click:minute="$refs.menuTimeEnd.save(endTime)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
              <v-col class="mx-0 px-0 py-0">
                <v-text-field
                  dense
                  v-model="endTime"
                  @change="setTimeRequest"
                  :disabled="pickerDisabled"
                  hide-details="auto"
                  :rules="rulesTime"
                  :error-messages="errorMessage"
                  color="tertiary"
                  class="mr-4 align-center fix-input-align"
                  @input="checkTimeDifference('endTime')"
                >
                    <template v-slot:label>
                      <span v-if="endTime" class="blue--text"
                        >Hora de fin
                      </span>
                      <span v-else>Hora de fin</span>
                      <span class="asterisc"> *</span>
                    </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row >
        <v-row class="mt-n9 mb-0">
          <v-col md="11" sm="11" xs="11" class="ml-9">
            <div class="warn-message">{{ timeLagMessage }}</div>
          </v-col>
        </v-row>
        

        <v-divider></v-divider>

        <Emails
          v-if="selectedGenerateArray == 'Programar'"
          :sendSelectedEmails="getSelectedEmails"
        />

        <v-row class="mt-2 mb-10">
          <v-col>
            <div class="d-flex justify-start">
              <v-btn
                color="tertiary white--text"
                outlined
                depressed
                :disabled="
                  selectedGenerateArray != 'Programar'
                    ? !valid || !selectedDateRange || !selectedThings[0]
                    : !valid || !selectedThings[0]
                "
                rounded
                @click="clear"
                :loading="submitLoading"
                >{{ 'Cancelar' }}</v-btn
              >
            </div>
          </v-col>
          <v-col>
            <div class="d-flex justify-end">
              <!---<v-btn
                color="tertiary white--text"
                depressed
               :disabled="!valid || !selectedDateRange || !selectedThings[0]"
                rounded
                @click="submit"
                :loading="submitLoading"
                >{{
                  selectedGenerateArray != 'Programar'
                    ? 'OBTENER INFORME'
                    : 'PROGRAMAR INFORME'
                }}</v-btn
              >-->

              <v-btn
                color="tertiary white--text"
                depressed
                rounded
                :disabled="
                  selectedGenerateArray != 'Programar'
                    ? !valid ||
                      !selectedDateRange ||
                      maxSelectedThngsReachedMsg ||
                      !selectedThings[0] ||
                      submitLoading
                    : !valid ||
                      !selectedThings[0] ||
                      maxSelectedThngsReachedMsg ||
                      !selectedEmails[0] ||
                      submitLoading
                "
                @click="submit"
                :loading="submitLoading"
                v-on:click="disabled"
                >{{
                  selectedGenerateArray != 'Programar'
                    ? 'OBTENER INFORME'
                    : 'PROGRAMAR INFORME'
                }}</v-btn
              >
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import { ThingsHelpers, AgentsHelpers, TagsHelpers } from '@/helpers/mainExports.js'
import PersonsHelpers from '@/helpers/persons/personsHelpers'
import moment from 'moment/moment'
import { mapActions, mapGetters } from 'vuex'
import { i18n } from '@leapsight/portal'
import store from '@/store'
import SpeedLimit from './partials/SpeedLimit'
import GeofenceAgent from './partials/GeofenceAgent.vue'
import TimeLimit from './partials/TimeLimit'
import { SvgIcon } from '@leapsight/styleguide'
import Dialog from '@/components/dialog/Dialog'
import { parseJwt } from '@leapsight/styleguide'
import { connectionService } from '@leapsight/styleguide'
import axios from 'axios'
import { GeofencesHelpers } from '@/helpers/mainExports.js'
import CreateZoneModal from './createZoneModal'
import CreateZone from './createZone.vue'
import ProgramReport from './programReport.vue'
import Emails from './emails.vue'
import Notifications from './partials/notifications/Notifications.vue'
import API_request from '@/api/reports'
import { firebaseServices } from '@leapsight/styleguide'
import BaseFilter from '@/components/Filter/BaseFilter.vue'

export default {
  components: {
    SpeedLimit,
    GeofenceAgent,
    TimeLimit,
    SvgIcon,
    Dialog,
    CreateZone,
    CreateZoneModal,
    ProgramReport,
    Emails,
    Notifications,
    BaseFilter
  },
  data() {
    return {
      timeLagMessage: "",
      allTags: [],
      filteredTags: [],
      timeRules: [
        value =>
          !!value ||
          i18n.t('fleet_management.agents.create.errors.field_required'),
        value =>
          /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/gm.test(value) ||
          i18n.t(
            'fleet_management.agents.create.errors.time_range_format_error'
          )
      ],
      rulesTime: [
        value => !!value || 'El campo es obligatorio',
        value =>
          /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/gm.test(value) ||
          'El horario debe estar en el formato HH:MM'
      ],
      pickerDisabled: false,
      selectedTimesPeriods: '',
      selectedEmails: [],
      selectedNotificationEmail: false,
      typeOfReportList: ['Trayecto', 'Diario'],
      typeOfReportListVia: ['Puntos', 'Tramos'],
      typeOfZonesList: ['Todas', 'Dentro de zona', 'Fuera de zona'],
      detentionTime: 10,
      starTingtimeLapseMoving: '',
      stopTimeLapseMoving: '',
      minKm: '',
      startTripList: [
        'Período de tiempo en movimiento mínimo',
        'Cantidad de Kms mínimos recorridos sin paradas'
      ],
      startTripSelected: '',
      reload_createZone: 0,
      GeofencesObjList: [],
      outsideZone: '0',
      insideZone: '0',
      geofencesIdList: [],
      typeOfZones: '',
      typeOfReportConsumoCombustible: '',
      typeOfReportVelPorTipoVia: 'Tramos',
      fromDateMenu: false,
      fromDateVal: null,
      fromDateMenuEnd: false,
      fromDateValEnd: null,
      loading: false,
      serviceNotFound: false,
      speedLimit: '',
      name: '',
      endTime: moment(new Date()).format('HH:mm'),
      maxTime: '',
      maxDate: '',
      startTime: '00:00',
      selectedDateRange: null,
      generateArray: ['Generar Ahora', 'Programar'],
      selectedGenerateArray: 'Generar Ahora',
      conditionSelected: '',
      menuTimeStart: false,
      menuTimeEnd: false,
      ThingsdateRangeArray: [
        'Más de 24hs',
        '2 Días',
        '3 Días',
        '1 Semana ',
        '1 Mes '
      ],

      dateRangeArray: [
        'Hoy',
        'Últimas 24hs',
        'Ayer',
        '1 Semana',
        '2 Semanas',
        '1 mes',
        'Personalizado'
      ],
      conditionsAvailables: [],
      isCombinable: false,
      conditionsForTimeComponent: [],
      conditionsSelected: [
        {
          name: {},
          agent: '',
          value: {}
        }
      ],
      submitLoading: false,
      allThings: [],
      filteredThings: [],
      thingsLoading: true,
      selectedThings: [],
      detentionTimeRules: [
        v => v > 2 || 'El valor debe ser mayor a 2 minutos',
        v => v < 721 || 'El valor debe ser menor  a 720 minutos (12 hs)'
      ],
      numericRules: [
        v => /^[0-9]+$/gi.test(v) || 'Solo se admiten valores numericos'
      ],
      integerRules: [
        v =>
          v === null ||
          v === '' ||
          /^[1-9][0-9]*$/.test(v) ||
          'Ingresa un número entero válido y mayor que cero'
      ],
      kmsRules: [
        v => v < 1000 || 'Los kilometros no pueden superar los 999 kms'
      ],
      zoneRules: [
        v => (v != null && v != '') || 'Ingresa un número entero válido y mayor o igual a cero',
        v => /^0$|^[1-9][0-9]*$/.test(v) || 'Ingresa un número entero válido y mayor o igual que cero',
        v => v < 10000000000 || 'Los minutos no pueden superar los 9999999999m'
      ],
      speedRules: [
        v => !!v || i18n.t('Campo obligatorio entre 10 km/h y 250 Km/h'),
        v => (v && v >= 10) || 'La velocidad debe estar entre 10 km/h y 250 Km/h',
        v =>
          (v && v <= 250) || 'La velocidad debe estar entre 10 km/h y 250 Km/h'
      ],
      nameRules: [
        v =>
          !!v || i18n.t('fleet_management.agents.create.errors.field_required'),
        v =>
          /^[a-zA-ZÀ-ÿ0-9 _-]{0,60}$/.test(v) ||
          'Sólo se aceptan letras (incluyendo tildes), números, espacios y guiones',
        v =>
          v.length <= 50 ||
          'El nombre no debe tener mas de 50 caracteres',
        v =>
          v.length >= 2 ||
          'El nombre debe tener al menos 2 caracteres'
      ],
      firstConditionRules: [v => !!v || 'Campo Obligatorio'],
      agents: [],
      valid: true,
      errorName: '',
      rpmMinima: null,
      maxSelectedThngsReachedMsg: '',
      scheduledReports: [],
      hasScheduledReportRole: false
    }
  },
  methods: {
    ...mapActions('reports', ['setOndemand']),
    ...mapActions('ui', ['setSnackbar']),
    setIsFilterApplied(value) {
      //this.isFilterApplied = value
      console.log('FILTER APPLIED',value)
    },
    setThingsApplied(value) {
      this.selectedThings = value;
    },
    async setAllTags() {
      const tagsResult = await TagsHelpers.getTags()
      const tags = []
      tags.splice(0, Infinity, ...tagsResult.args[0])
      this.allTags.splice(0, Infinity, ...tags)
      this.filteredTags = this.allTags;
    },
    selectedEmail() {
      //console.log(this.selectedNotificationEmail)
    },
    /*
    reloadThings() {
      this.initializeConditionsAndThings()
      this.setAllTags()
    },
    */
    zones() {
        return this.GeofencesObjList[0] ? this.GeofencesObjList : null
    },

    bodyDetail() {
      if (  this.conditionSelected == 'Informe de control de zonas') {
        if (this.typeOfZones) {
          switch (this.typeOfZones) {
            case 'Todas':
              return {
                'Tiempo dentro de zona': this.insideZone,
                'Tiempo fuera de zona': this.outsideZone
              }
            case 'Dentro de zona':
              return { 'Tiempo dentro de zona': this.insideZone }
            case 'Fuera de zona':
              return { 'Tiempo fuera de zona': this.outsideZone }
          }
        }
        return {}
      }

      if (this.conditionSelected == 'Detenciones') {
        return { criterio_detencion: this.detentionTime }
      }
      
      if (this.conditionSelected == 'Informe de viajes') {
        return {
          tolerancia:
            this.startTripSelected == 'Período de tiempo en movimiento mínimo'
              ? this.starTingtimeLapseMoving
              : this.minKm,
          criterio_viaje:
            this.startTripSelected == 'Período de tiempo en movimiento mínimo'
              ? 'min'
              : 'kms',
          criterio_parada: this.stopTimeLapseMoving
        }
      }

      if (this.conditionSelected === 'Exceso de velocidad') {
        if (this.speedLimit) {
          return { 'Tope Km/h': parseInt(this.speedLimit, 10) }
        }
      }

      if (this.conditionSelected == 'Consumo de combustible por kilómetros recorridos') {
        return {
          rpm_minima: this.rpmMinima ? this.rpmMinima : 'null',
          typeOfReport: this.typeOfReportConsumoCombustible
        }
      }

      if (this.conditionSelected == 'Velocidad por tipo de vía') {
        return {
          typeOfReport: this.typeOfReportVelPorTipoVia
        }
      }
    },

    async getGeofence(id) {
      try {
        const response = await GeofencesHelpers.getGeofence(id)
        return response
      } catch (e) {
        console.error(e)
      }
    },
    async getGeoFencesObjects() {
      const newArray = []
      this.GeofencesObjList[0]

      for (const id of this.geofencesIdList) {
        newArray.push(await this.getGeofence(id))
      }

      this.GeofencesObjList = newArray
    },
    getSelectedTimesPeriods(selectedTimesPeriods) {
      this.selectedTimesPeriods = selectedTimesPeriods
    },
    getSelectedEmails(selectedEmails) {
      this.selectedEmails = selectedEmails
    },
    reportNameFormat() {
      if (this.name) {
        return this.name
      }
      if (this.conditionSelected === 'Detenciones') {
        return 'Informe de Detenciones mayores a ' + this.detentionTime + ' min'
      }
      if (this.conditionSelected === 'Exceso de velocidad') {
        return this.conditionSelected + ' ' + this.speedLimit + 'Km/h'
      } else {
        return this.conditionSelected
      }
    },
    reportTypeFormat() {
      switch (this.conditionSelected) {
        case 'Exceso de velocidad':
          return 'exceso_velocidad'
        case 'Kmts recorridos':
          return 'kms_recorridos'
        case 'Móviles que no reportan':
          return 'things_que_no_reportan'
        case 'Informe de control de zonas':
          return 'informe_zonas'
        case 'Informe de viajes':
          return 'informe_viajes'
        case 'Detenciones':
          return 'detenciones'
        case 'Histórico de eventos':
          return 'historico_eventos'
        case 'Consumo de combustible por kilómetros recorridos':
          return 'consumo_combustible'
        case 'Informe de Temperatura':
          return 'informe_temperatura'
        case 'Velocidad por tipo de vía':
          return 'excesos_por_via'
        case 'Informe de Múltiples Temperaturas':
          return 'informe_multi_temperatura'
      }
    },
    reportLabel(reportName) {
      switch (reportName) {
        case 'exceso_velocidad':
          return 'Exceso de velocidad'
        case 'kms_recorridos':
          return 'Kmts recorridos'
        case 'things_que_no_reportan':
          return 'Móviles que no reportan'
        case 'informe_zonas':
          return 'Informe de control de zonas'
        case 'informe_viajes':
          return 'Informe de viajes'
        case 'detenciones':
          return 'Detenciones'
        case 'exceso_tipo_via':
          return 'Exceso por tipo de via'
        case 'historico_eventos':
          return 'Histórico de eventos'
        case 'consumo_combustible':
          return 'Consumo de combustible por kilómetros recorridos'
        case 'informe_temperatura':
          return 'Informe de Temperatura'
        /*case 'excesos_por_via':
          return 'Vel x tipo vía'*/
      }
    },
    clear() {
        this.filterThingsByCondition(),
        (this.conditionSelected = ''),
        (this.selectedThings = []),
        (this.timeLagMessage = ""),
        (this.pickerDisabled = false),
        (this.selectedTimesPeriods = ''),
        (this.selectedEmails = []),
        (this.selectedNotificationEmail = false),
        (this.detentionTime = 10),
        (this.starTingtimeLapseMoving = ''),
        (this.stopTimeLapseMoving = ''),
        (this.minKm = ''),
        (this.startTripSelected = ''),
        (this.reload_createZone = 0),
        (this.GeofencesObjList = []),
        (this.outsideZone = '0'),
        (this.insideZone = '0'),
        (this.geofencesIdList = []),
        (this.typeOfZones = ''),
        (this.typeOfReportConsumoCombustible = ''),
        (this.typeOfReportVelPorTipoVia = 'Tramos'),
        (this.fromDateMenu = false),
        (this.fromDateVal = null),
        (this.fromDateMenuEnd = false),
        (this.fromDateValEnd = null),
        (this.loading = false),
        (this.serviceNotFound = false),
        (this.speedLimit = ''),
        (this.name = ''),
        (this.endTime = moment(new Date()).format('HH:mm')),
        (this.maxTime = ''),
        (this.maxDate = ''),
        (this.startTime = '00:00'),
        (this.selectedDateRange = null),
        (this.selectedGenerateArray = 'Generar Ahora'),
        (this.menuTimeStart = false),
        (this.menuTimeEnd = false),
        (this.isCombinable = false),
        (this.submitLoading = false),
        (this.valid = true),
        (this.errorName = ''),
        (this.rpmMinima = null),
        (this.maxSelectedThngsReachedMsg = '')
    },
    decodeToken() {
      const jwt = localStorage.getItem('ACCESS_TOKEN')
      const jwtDecodeResult = parseJwt(jwt)
      return jwtDecodeResult
    },
    resetTimeStart() {
      this.startTime = '00:00'
    },
    getCountryId() {
      const country_id = localStorage.getItem('country_id')
      //console.log(country_id)
      return country_id
    },
    getAccountId() {
      const data = this.decodeToken()
      // console.log(data)
      return data.meta.business_account_id
    },
    changeEndTime() {
      this.endTime = '23:59'
    },
    checkTimeLag(endDate, warnMessage) {
      const reportEndDate = moment(endDate,"DD-MM-YYYY HH:mm").toDate();
      const currentdate = new Date();
      currentdate.setHours(currentdate.getHours()-3);

      if (currentdate < reportEndDate) {
        this.timeLagMessage = warnMessage ? warnMessage : process.env.VUE_APP_TIME_DELAY_MSG1
      } else {
        this.timeLagMessage = ""
      }
      
    },
    setTimeRequest() {
      console.log("SET TIME REQUEST")
      const today = moment(new Date())
      const pickedEndDate = moment(this.fromDateDispEnd, 'DD-MM-YYYY')
      const oneMonthFromInitDate = moment(this.fromDateDisp, 'DD-MM-YYYY').add(
        1,
        'M'
      )
      const maxDateUNIX = Math.min(today.unix(), oneMonthFromInitDate.unix())

      const from_hour = '00:00'
      const to_hour = new Date(today - 30 * 60000)
        .toTimeString()
        .split(' ')[0]
        .slice(0, -3)  

      // console.log("Start (Date)", this.fromDateDisp)
      // console.log("End (Date)", this.fromDateDispEnd)

      // console.log("Limit by length (UNIX)", oneMonthFromInitDate.unix())
      // console.log("Limit date (UNIX)", today.unix())
      // console.log("maxDate (UNIX)",maxDateUNIX)

      if (this.selectedGenerateArray != 'Programar' && pickedEndDate.unix() > maxDateUNIX) {
        this.fromDateMenuEnd = moment.unix(maxDateUNIX).format('YYYY-MM-DD')
        this.errorMessageDateFrom = 'El informe debe ser de menos de 1 mes'
      } else {
        this.errorMessageDateFrom = ''
      }

      // console.log("Limit by length (Date)", oneMonthFromInitDate.format('YYYY-MM-DD'))
      // console.log("Limit date (Date)", today.format('YYYY-MM-DD'))
      this.maxDate = moment.unix(maxDateUNIX).format('YYYY-MM-DD')

      // console.log("maxDate (Date)",this.maxDate)

      if (
        this.maxDate == this.fromDateValEnd ||
        this.fromDateValEnd == undefined
      ) {
        this.maxTime = to_hour
      } else {
        this.maxTime = '23:59'
      }

      let from_datetime = null
      let to_datetime = null

      if (this.selectedGenerateArray == 'Programar') {
        from_datetime = this.fromDateDisp + ' ' + '00:00'
        to_datetime = this.fromDateDispEnd + ' ' + '00:00'
        return { from_datetime, to_datetime }
      }
      switch (this.selectedDateRange) {
        case 'Hoy':
          from_datetime =
            moment(new Date()).format('DD-MM-YYYY') + ' ' + from_hour
          to_datetime = moment(new Date()).format('DD-MM-YYYY') + ' ' + to_hour

          this.checkTimeLag(to_datetime)
          return { from_datetime, to_datetime }
        /*
        'Más de 24hs',
        '2 Días',
        '3 Días',
        '1 Semana',
        '1 Mes',
        'Personalizado',
        */
        case 'Más de 24hs':
          to_datetime =
            moment(new Date())
              .subtract(1, 'days')
              .format('DD-MM-YYYY') +
            ' ' +
            moment(new Date()).format('HH:mm')
          from_datetime =
            today.format('DD-MM-YYYY') + ' ' + today.format('HH:mm')

          // console.log(' fechas ', from_datetime, to_datetime)
          return { from_datetime, to_datetime }

        case '2 Días':
          to_datetime =
            moment(new Date())
              .subtract(2, 'days')
              .format('DD-MM-YYYY') +
            ' ' +
            moment(new Date()).format('HH:mm')
          from_datetime =
            today.format('DD-MM-YYYY') + ' ' + today.format('HH:mm')

          return { from_datetime, to_datetime }

        case '3 Días':
          to_datetime =
            moment(new Date())
              .subtract(3, 'days')
              .format('DD-MM-YYYY') +
            ' ' +
            moment(new Date()).format('HH:mm')
          from_datetime =
            today.format('DD-MM-YYYY') + ' ' + today.format('HH:mm')

          return { from_datetime, to_datetime }
        /*
        case '1 Semana ':
          to_datetime =
            moment(new Date())
              .subtract(7, 'days')
              .format('DD-MM-YYYY') +
            ' ' +
            moment(new Date()).format('HH:mm')
          from_datetime =
            today.format('DD-MM-YYYY') + ' ' + today.format('HH:mm')

          this.checkTimeLag(to_datetime)
          return { from_datetime, to_datetime }
        
        case '1 Mes ':
          to_datetime =
            moment(new Date())
              .subtract(1, 'months')
              .format('DD-MM-YYYY') +
            ' ' +
            moment(new Date()).format('HH:mm')
          from_datetime =
            today.format('DD-MM-YYYY') + ' ' + today.format('HH:mm')

          this.checkTimeLag(to_datetime)
          return { from_datetime, to_datetime }
        */
        case 'Últimas 24hs':
          from_datetime =
            moment(new Date())
              .subtract(1, 'days')
              .format('DD-MM-YYYY') +
            ' ' +
            moment(new Date()).format('HH:mm')
          to_datetime = today.format('DD-MM-YYYY') + ' ' + today.format('HH:mm')

          // console.log(' fechas ', from_datetime, to_datetime)
          this.checkTimeLag(to_datetime)
          return { from_datetime, to_datetime }

        case 'Ayer':
          from_datetime =
            moment(new Date())
              .subtract(1, 'days')
              .format('DD-MM-YYYY') +
            ' ' +
            '00:00'
          to_datetime =
            moment(new Date())
              .subtract(1, 'days')
              .format('DD-MM-YYYY') +
            ' ' +
            '23:59'

          this.checkTimeLag(to_datetime)
          return { from_datetime, to_datetime }

        case '1 Semana':
          from_datetime =
            moment(new Date())
              .subtract(7, 'days')
              .format('DD-MM-YYYY') +
            ' ' +
            from_hour
          to_datetime = moment(new Date()).format('DD-MM-YYYY') + ' ' + to_hour
          this.checkTimeLag(to_datetime)
          return { from_datetime, to_datetime }

        case '2 Semanas':
          from_datetime =
            moment(new Date())
              .subtract(14, 'days')
              .format('DD-MM-YYYY') +
            ' ' +
            from_hour
          to_datetime = moment(new Date()).format('DD-MM-YYYY') + ' ' + to_hour
          this.checkTimeLag(to_datetime)
          return { from_datetime, to_datetime }

        case '1 mes':
          from_datetime =
            moment(new Date())
              .subtract(1, 'months')
              .format('DD-MM-YYYY') +
            ' ' +
            from_hour
          to_datetime = moment(new Date()).format('DD-MM-YYYY') + ' ' + to_hour
          this.checkTimeLag(to_datetime)
          return { from_datetime, to_datetime }

        case 'Personalizado':
          if (this.fromDateValEnd) {
            const endDate = moment(this.fromDateValEnd, 'YYYY-MM-DD').toDate()
            var formatEndDate = moment(endDate).format('DD-MM-YYYY')
          } else {
            var formatEndDate = moment(new Date()).format('DD-MM-YYYY')
          }

          if (this.fromDateVal) {
            const startDate = moment(this.fromDateVal, 'YYYY-MM-DD').toDate()
            var formatStartDate = moment(startDate).format('DD-MM-YYYY')
          } else {
            var formatStartDate = moment(new Date()).format('DD-MM-YYYY')
          }

          from_datetime = formatStartDate + ' ' + this.startTime
          to_datetime =
            formatEndDate + ' ' + (this.endTime ? this.endTime : to_hour)
          this.checkTimeLag(to_datetime, process.env.VUE_APP_TIME_DELAY_MSG2)
          return { from_datetime, to_datetime }
      }
    },
    filterThingsByCondition(condition) {
      this.selectedThings = []
      if (this.allThings.length > 0) {
        switch (condition) {
          case 'Consumo de combustible por kilómetros recorridos':
            this.filteredThings = this.findServiceInThings('telemetry', this.allThings)
            break
          case 'Informe de Temperatura':
            this.filteredThings = this.findServiceInThings('temperature_sensor', this.allThings)
            break
          case 'Velocidad por tipo de vía':
            this.filteredThings = this.findServiceInThings('speed_limit_by_road_type', this.allThings)
            break
          case 'Informe de Múltiples Temperaturas':
            this.filteredThings = this.findServiceInThings('temperature_multi_sensor', this.allThings)
            break
          default:
            this.filteredThings = [...this.allThings]
          }
          this.filteredTags = this.filteredTagsFunction(this.allTags, this.filteredThings) 
      }

    },
    initializeConditionsAndThings() {
      ThingsHelpers.getThingsList().then(response => {
        if (response.args[0].length > 0) {
          const things = response.args[0]
          if (this.findServiceInThings('telemetry', things).length > 0) {
            this.availableReportList.push('Consumo de combustible por kilómetros recorridos')
            this.availableReportList.sort()
          }
          if (this.findServiceInThings('temperature_sensor', things).length > 0) {
            this.availableReportList.push('Informe de Temperatura')
            this.availableReportList.sort()
          }
          if (this.findServiceInThings('speed_limit_by_road_type', things)) {
            this.availableReportList.push('Velocidad por tipo de vía')
            this.availableReportList.sort()
          }
          if (this.findServiceInThings('temperature_multi_sensor', things).length > 0) {
            this.availableReportList.push('Informe de Múltiples Temperaturas')
            this.availableReportList.sort()
          }

          this.allThings = things
          this.filteredThings = things

        } else {
            const snackbar = {
              color: 'warn',
              text: 'No hay entidades disponibles.'
            }
            this.setSnackbar(snackbar)
        }
      }).catch((err) => {
        console.error(err);
      })
      .finally(() => {
        // console.log('Experiment completed');
      });
      
    },

    getThingsList() {
      ThingsHelpers.getThingsList().then(response => {
        store.dispatch('things/setResponseError', false)
        if (response.args[0].length > 0) {
          const things = response.args[0]

          const reportFuelConsumption = 'Consumo de combustible por kilómetros recorridos'
          const reportTemperature_Sensor = 'Informe de Temperatura'

          const reportExcesos_por_via = 'Velocidad por tipo de vía'

          const filteredThingsTelemetry = this.filteredThingsFunction(
            things,
            'telemetry'
          )
          const filteredThingsTemperature_Sensor = this.filteredThingsFunction(
            things,
            'temperature_sensor'
          )
          const filteredThingsExcesos_por_via = this.filteredThingsFunction(
            things,
            'speed_limit_by_road_type'
          )

          if (filteredThingsTelemetry.length > 0) {
            this.availableReportList.push(reportFuelConsumption)
            this.availableReportList.sort()
          }
          // eslint-disable-next-line @typescript-eslint/camelcase
          if (filteredThingsTemperature_Sensor.length > 0) {
            this.availableReportList.push(reportTemperature_Sensor)
            this.availableReportList.sort()
          }
          // eslint-disable-next-line @typescript-eslint/camelcase
          if (filteredThingsExcesos_por_via.length > 0) {
            this.availableReportList.push(reportExcesos_por_via)
            this.availableReportList.sort()
          }

          switch (this.conditionSelected) {
            case 'Consumo de combustible por kilómetros recorridos':
              this.allThings = filteredThingsTelemetry
              break
            // eslint-disable-next-line @typescript-eslint/camelcase
            case 'Informe de Temperatura':
              // eslint-disable-next-line @typescript-eslint/camelcase
              this.allThings = filteredThingsTemperature_Sensor
              break
            // eslint-disable-next-line @typescript-eslint/camelcase
            case 'Velocidad por tipo de vía':
              // eslint-disable-next-line @typescript-eslint/camelcase
              console.log('reportExcesos_por_via')
              this.allThings = filteredThingsExcesos_por_via
              break
            default:
              this.allThings = things
          }

          this.thingsLoading = false
          //ELSE setear respuesta de no hay info para mostrar
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        // console.log('Experiment completed');
      });
    },

    async getAgents() {
      const response = await AgentsHelpers.getAgents()
      if (!response.hasOwnProperty('error')) {
        this.agents = response.args[0]
      }
    },

    selectAll() {
      this.$nextTick(() => {
        if (this.selectedAllThings) {
          this.selectedThings = []
          this.updateThings()
        } else {
          this.selectedThings = this.allThings
          this.updateThings()
        }
      })
    },

    pickThingData(thingObj) {
      return {
        thing_id: thingObj.id,
        domain: thingObj.info.domain,
        engine_number: thingObj.info.engine_number,
        label: thingObj.info.label,
        year: thingObj.info.year,
        tipo_vehiculo: thingObj.info.subtype,
        tipo_entidad: thingObj.type
      }
    },
    async geofenceEmit(data, index) {
      const geofences = {}
      for (let i = 0; i < data.length; i++) {
        const element = data[i]
        const id = element.id
        const name = element.properties.name
        geofences[id] = name
        Object.assign(this.conditionsSelected[index].value, {
          [id]: name
        })
      }
      const geoFenceId = Object.keys(geofences)
      this.geofencesIdList = geoFenceId
    },
    speedEmit(speed, index) {
      Object.assign(this.conditionsSelected[index].value, {
        // eslint-disable-next-line @typescript-eslint/camelcase
        speed_limit: Number(speed)
      })
    },
    addCondition() {
      this.conditionsSelected.push({
        name: {},
        agent: '',
        value: {}
      })
      //Evitamos que se pueda mutar de componente una vez seteada la condicion
      //Solo se puede volver a editar si se elimina la condición siguiente
      this._preventChangeConditionsSetted()
      // Calcular las opciones disponibles en base a la primer condicion
      this._conditionsAvailables()
    },
    removeCondition(index) {
      this.conditionsSelected.splice(index, 1)
      this.conditionsAvailables.splice(index, 1)
      this.conditionsForTimeComponent.splice(index, 1)
      this._conditionsAvailables()
      this.$nextTick(() => {
        this._preventChangeConditionsSetted()
      })
    },
    _preventChangeConditionsSetted() {
      this.$nextTick(() => {
        for (let i = 0; i < this.conditionsSelected.length - 1; i++) {
          this.$refs[`select-${i}`][0].readonly = true
        }
      })
    },
    _setAgent(val, index) {
      this.$set(this.conditionsSelected[index], 'name', val)
      this.$set(this.conditionsSelected[index], 'agent', val.component)
      //Dejo el value vacío para que reciba de los emits la info
      this.$set(this.conditionsSelected[index], 'value', {})
      this.conditionsForTimeComponent.splice(index, 1, val.id)
    },
    _conditionsAvailables() {
      //Función que retorna las posibilidades de combinación entre condiciones
      const arrLength = this.conditionsSelected.length
      let index
      //En caso que haya mas de 1 condición mi referencia es la última seteada.
      //De ahi el juego de valor para el indice
      if (arrLength > 1) index = arrLength - 2
      else index = arrLength - 1

      const obj = this.conditionsSelected[index]
      const alias = obj.name.alias
      const isCombinable = this._isCombinable(obj.name)
      if (isCombinable) {
        const tempArr = []
        const response = AgentsHelpers.getCombinations(alias)
        for (let i = 0; i < this.availableReportList.length; i++) {
          const element = this.availableReportList[i]
          // Hay combinaciones posibles
          response.map(item => {
            if (item == element.alias) tempArr.push(element)
          })
        }
        this.$set(this.conditionsAvailables, index + 1, tempArr)
      }
    },
    _isCombinable(val) {
      //Esta función retorna true o false en caso de que la condición sea combinable
      // y se encarga de habilitar o deshabilitar el boton 'añadir condición'
      let valueToReturn = false
      const alias = val.alias
      const response = AgentsHelpers.getCombinations(alias)
      if (response.length > 0) {
        this.isCombinable = true
        valueToReturn = true
      } else this.isCombinable = false
      return valueToReturn
    },
    onChangeName(val) {
      this.name = val
    },

    onChangeNumber(val) {
      const intValue = parseInt(val)
      if (!isNaN(intValue)) {
        this.rpmMinima = intValue
      } else {
        this.rpmMinima = null
      }
    },

    onSelectReportType(val, index) {
      this.clear()
      this.conditionSelected = val
      this.geofencesIdList = []
      this._setAgent(val, index)
      this._preventChangeConditionsSetted()
      this._isCombinable(val)
      this.filterThingsByCondition(val);
      firebaseServices.logEvent(firebaseServices.analytics, 'inp_informe_tipo')
    },
    updateThings() {
      const totalSelected = this.thingsSelectedCount
      if (totalSelected > process.env.VUE_APP_MAX_SELECTED_THINGS) {
        this.maxSelectedThngsReachedMsg =
          'Se admiten como máximo ' +
          process.env.VUE_APP_MAX_SELECTED_THINGS +
          ' entidades'
      } else {
        this.maxSelectedThngsReachedMsg = ''
      }

      const formThings = this.selectedThings
      const things = {}

      for (let index = 0; index < formThings.length; index++) {
        const element = formThings[index]
        const id = element.id
        const name = element.info.label
        if (this.conditionSelected === 'Exceso por tipo de via') {
          const subtype = element.info.subtype // Obtener el subtype
          // Asignar un objeto que contenga el nombre y el subtype
          things[id] = { name, subtype }
        } else {
          things[id] = name
        }
      }
    },
    goBack() {
      this.$router.push({ name: 'Agents' })
    },
    async submit() {
      const personId = await connectionService.getBusinessUserId()

      this.submitLoading = true
      await this.getGeoFencesObjects()
      const time = this.setTimeRequest()
      let tipo_informe = this.reportTypeFormat()

      const userEmail = store.getters['auth/user'].username
      // const localuser = localStorage.getItem('user')
      /**
       * Diferencia en minutos
       */
      // Fecha pasada en formato ISO (YYYY-MM-DDTHH:MM:SSZ)
      //const pastDateString = String(time.to_datetime)

      // Convierte la cadena de fecha pasada a un objeto Date
      const pastDateGet = time.to_datetime
      // Divide la fecha y la hora
      const [datePart, timePart] = pastDateGet.split(' ')

      // Divide la fecha en día, mes y año
      const [day, month, year] = datePart.split('-').map(Number)

      // Divide la hora en horas y minutos
      const [hours, minutes] = timePart.split(':').map(Number)

      // Crea un objeto Date usando los componentes extraídos
      const pastDate = new Date(year, month - 1, day, hours, minutes)
      //console.log(pastDate)
      // Obtén la fecha y hora actual
      const currentDate = new Date()

      // Calcula la diferencia en milisegundos
      const differenceInMilliseconds = currentDate - pastDate

      // Convierte la diferencia de milisegundos a minutos
      const noReportanDesde = Math.floor(differenceInMilliseconds / 1000 / 60)

      //const nombreInforme = String(this.reportNameFormat())
      const bodyDetails = this.bodyDetail()

      if (
        tipo_informe === 'consumo_combustible' &&
        bodyDetails.typeOfReport === 'Diario'
      ) {
        //nombreInforme = 'informe_consumo_diario'
        tipo_informe = 'consumo_combustible_diario'
        //bodyDetails.typeOfReport
      }
      if (
        tipo_informe === 'excesos_por_via' &&
        bodyDetails.typeOfReport === 'Puntos'
      ) {
        //nombreInforme = 'informe_consumo_diario'
        tipo_informe = 'excesos_por_via_puntos'
        //bodyDetails.typeOfReport
      }
      if (
        tipo_informe === 'excesos_por_via' &&
        bodyDetails.typeOfReport === 'Tramos'
      ) {
        //nombreInforme = 'informe_consumo_diario'
        tipo_informe = 'excesos_por_via_tramos'
      }

      console.log('tipo_informe---->', tipo_informe)
      const body_collector = {
        report_last_valid_signal: noReportanDesde,
        nombre_informe: String(this.reportNameFormat()),
        account_id: String(this.getAccountId()),
        //'mrn:account:business:aef14e77-5834-4e23-96a2-b29664b95f25', //String(this.getAccountId()),
        //'mrn:account:business:2f95ecbf-6282-4da0-bbba-a8fd7eabc2ad' /*"String(this.getAccountId()),*/,
        // country_id: String(this.getCountryId()),
        tipo_informe: String(tipo_informe),
        zonas: this.zones(),
        detalles: bodyDetails,
        /*entities: [
          {
            thing_id:
              'mrn:thing:vehicle:399cefec-8b10-4c57-bbde-d74c8ce9dfd9@aef14e77-5834-4e23-96a2-b29664b95f25',
            tipo_entidad: 'mrn:thing:vehicle',
            tipo_vehiculo: 'car'
          }
        ],*/
        entities: this.selectedThings.map(element =>
          this.pickThingData(element)
        ),
        from_datetime: String(time.from_datetime),
        to_datetime: String(time.to_datetime),
        user_id: personId,
        send_email: false, //this.selectedNotificationEmail,
        email_address: this.selectedNotificationEmail ? userEmail : '',
        email_to:
          this.selectedGenerateArray == 'Programar'
            ? this.selectedEmails
            : null,
        run_periodicity:
          this.selectedGenerateArray == 'Programar'
            ? this.selectedTimesPeriods.run_periodicity
            : null,
        run_weekdays:
          this.selectedGenerateArray == 'Programar'
            ? this.selectedTimesPeriods.run_weekdays
            : null,
        run_monthday:
          this.selectedGenerateArray == 'Programar'
            ? this.selectedTimesPeriods.run_monthday
            : null
      }

      const removeEmptyOrNull = obj => {
        Object.keys(obj).forEach(
          k =>
            (obj[k] &&
              typeof obj[k] === 'object' &&
              removeEmptyOrNull(obj[k])) || obj[k] == 0 ||
            (!obj[k] && obj[k] !== undefined && delete obj[k])
        )
        return obj
      }

      //console.log(body_collector)
      const body = removeEmptyOrNull(body_collector)
      console.log('cleaned body_collector',body)
      // defino endpoint para enviar el body (programar o informes)
      var ondemand = this.selectedGenerateArray == 'Programar' ? false : true
      this.setOndemand(ondemand);
      try {
        const response = await API_request(ondemand ? 'informe' : 'programar', body, 'post')
        //const response = {
        //  status: 200
        //}
        if (response.status == 200) {
          this.$router.push('processing')
        } else {
          this.loading = false
          this.serviceNotFound = true
        }
      } catch (error) {
        this.loading = false
        this.serviceNotFound = true

        if (error.response) {
          const { status, data } = error.response
          const errorMessage =
            status === 500
              ? 'Error interno del servidor (500)'
              : status === 503
              ? 'Servicio no disponible (503)'
              : `Error en la solicitud (${status})`
          console.error(errorMessage, data)
        } else {
          console.error('Error desconocido:', error.message)
        }
        throw error
      }
    },
    findServiceInThings(service, things) {
      const serviceName = 'mrn:service:' + service
      const result = things.filter(thing => {
        return (
          thing &&
          thing.config &&
          thing.config.services &&
          thing.config.services[serviceName] &&
          thing.config.services[serviceName].status === 'active'
        )
      })
      return result;
    },

    /*
    filteredThingsFunction(things, service) {
      const thingsResult = things.filter(thing => {
        if (
          service === 'telemetry' &&
          thing &&
          thing.config &&
          thing.config.services &&
          thing.config.services['mrn:service:telemetry']
        ) {
          return (
            thing.config.services['mrn:service:telemetry'].status === 'active'
          )
        }
        if (
          service === 'temperature_sensor' &&
          thing &&
          thing.config &&
          thing.config.services &&
          thing.config.services['mrn:service:temperature_sensor']
        ) {
          return (
            thing.config.services['mrn:service:temperature_sensor'].status ===
            'active'
          )
        }
        if (
          service === 'speed_limit_by_road_type' &&
          thing &&
          thing.config &&
          thing.config.services &&
          thing.config.services['mrn:service:speed_limit_by_road_type']
        ) {
          return (
            thing.config.services['mrn:service:speed_limit_by_road_type'].status ===
            'active'
          )
        }

        return false
      })

      if (service === 'speed_limit_by_road_type') {
        thingsResult.map(thing => ({
          thing_id: thing.id || null, // Ajustar si la propiedad `id` tiene otro nombre
          tipo_entidad: thing.type || null, // Ajustar según la estructura del objeto
          tipo_vehiculo: thing.config?.vehicle_type || null // Ajustar si `vehicle_type` tiene otro nombre
        }))
      }

      return thingsResult
    },
    */
    filteredTagsFunction(tags, things) {
      const tagsResult = tags.filter( tag => {
        return things.find( thing => thing.info.tags && thing.info.tags.find( id => id == tag.id))
      })
      return tagsResult
    },

    /*
    checkThingsTelemetry() {
      setTimeout(() => {
        this.$nextTick(function() {
          this.initializeConditionsAndThings()
          this.setAllTags()
        })
      }, 1000)
    },
    */

    checkTimeDifference(item, index, type, typeMenu) {
      if (
        /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/gm.test(item.startTime) &&
        /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/gm.test(item.endTime) &&
        item.startTime > item.endTime
      ) {
        this.errorMessages[index] = i18n.t(
          'fleet_management.agents.create.errors.time_range_difference_error'
        )
      } else {
        this.errorMessages[index] = ''
      }
      const hours = type === 'startTime' ? item.startTime : item.endTime
      const rangeIsValid =
        item.endTime != null &&
        /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/gm.test(item.startTime) &&
        /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/gm.test(item.endTime) &&
        item.startTime <= item.endTime
      if (rangeIsValid) {
        this.save(index, type, typeMenu, hours)
      }
    },
  },
  watch: {
    conditionSelected: function(val) {
      if (val == 'Móviles que no reportan') {
        this.selectedDateRange = 'Más de 24hs'
      } else {
        this.selectedDateRange = null
      }
      this.selectedGenerateArray = 'Generar Ahora'
    }
  },
  computed: {
    isFormReady() {
      return this.allThings.length > 0
    },
    availableReportList() {

      if (this.hasScheduledReportRole) {
        if (this.scheduledReports) {
          this.scheduledReports.sort();
          return this.scheduledReports.map( r => this.reportLabel(r));
        } else {
          return []
        }
      } else {
        const reportList = [
          'Detenciones',
          'Exceso de velocidad',
          'Histórico de eventos', // Velocidades mayores a la dada
          'Informe de control de zonas', // Informe de zonas
          'Informe de viajes', // Informe de viajes
          'Kmts recorridos', // Kms Recorridos
          'Móviles que no reportan' // Things que no reportan
          //'Vel x tipo vía'
          // 'Exceso por tipo de via',
        ]

        if (this.findServiceInThings('telemetry', this.allThings).length > 0) 
          reportList.push('Consumo de combustible por kilómetros recorridos')

        if (this.findServiceInThings('temperature_sensor', this.allThings).length > 0) 
          reportList.push('Informe de Temperatura')

        if (this.findServiceInThings('speed_limit_by_road_type', this.allThings).length > 0) 
          reportList.push('Velocidad por tipo de vía')
        
        if (this.findServiceInThings('temperature_multi_sensor', this.allThings).length > 0) 
          reportList.push('Informe de Múltiples Temperaturas')
        
        reportList.sort()

        return reportList
      }
    },
    screenSize() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return true
        case 'sm':
          return true

        default:
          false
      }
    },
    fromDateDisp() {
      if (this.fromDateVal) {
        const formatToDate = moment(this.fromDateVal, 'YYYY-MM-DD').toDate()
        const formatToLocalDate = moment(formatToDate).format('DD-MM-YYYY')
        this.initDateValue = this.fromDateVal

        return formatToLocalDate
        // format date, apply validations, etc. Example below.
        // return this.fromDateVal ? this.formatDate(this.fromDateVal) : "";
      } else {
        this.initDateValue = moment(new Date()).format('YYYY-MM-DD')
        return moment(new Date()).format('DD-MM-YYYY')
      }
    },
    allAndOutsideZone() {
      if (this.typeOfZones == 'Todas') {
        return true
      }
      if (this.typeOfZones == 'Fuera de zona') {
        return true
      }
      return false
    },
    allAndInsideZone() {
      if (this.typeOfZones == 'Todas') {
        return true
      }
      if (this.typeOfZones == 'Dentro de zona') {
        return true
      }
      return false
    },
    fromDateDispEnd() {
      if (this.fromDateValEnd) {
        const formatToDate = moment(this.fromDateValEnd, 'YYYY-MM-DD').toDate()
        const formatToLocalDate = moment(formatToDate).format('DD-MM-YYYY')
        this.endDateValue = this.fromDateValEnd
        return formatToLocalDate
        // format date, apply validations, etc. Example below.
        // return this.fromDateVal ? this.formatDate(this.fromDateVal) : "";
      } else {
        this.endDateValue = moment(new Date()).format('YYYY-MM-DD')

        if (this.selectedGenerateArray == 'Programar') {
          return (this.endDateValue = moment(new Date())
            .add(12, 'M')
            .format('DD-MM-YYYY'))
        }
        return moment(new Date()).format('DD-MM-YYYY')
      }
    },
    ...mapGetters('auth', ['connection']),
    secondAgent() {
      const selected = this.secondCondition
      return selected.component
    },

    timeLimit() {
      if (this.firstCondition !== '') {
        return TimeLimit
      } else {
        return ''
      }
    },
    selectedAllThings() {
      return this.selectedThings.length === this.allThings.length
    },
    selectedSomeThings() {
      return this.selectedThings.length > 0 && !this.selectedAllThings
    },
    icon() {
      if (this.selectedAllThings) return 'mdi-close-box'
      if (this.selectedSomeThings) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    customNameFormat() {
      if (this.conditionSelected == 'Detenciones') {
        return 'Informe de Detenciones mayores a ' + this.detentionTime + ' min'
      }

      if (this.conditionSelected) {
        return this.conditionSelected
      }

    },
    thingsSelectedCount() {
      let totalCount = 0
      if (this.selectedThings && this.selectedThings.length > 0) {
        const selectedItems = this.selectedThings.map(id => {
          return this.allThings.find(element => element.id === id.id)
        })
        totalCount = selectedItems.reduce(function(prev, cur) {
          return prev + (cur.count ? cur.count : 1)
        }, 0)
      }
      return totalCount
    },
    amountConditions() {
      return this.availableReportList.length - 1
    }
  },

  created() {
      let checkConnAttempts = 0
      const checkConnIntervalId = setInterval(() => {
        checkConnAttempts++;
        console.log('Checking connection...')
        const connection = this.connection
        if (connection && connection.session && connection.session.isOpen) {
          console.log('...connection open')
          this.$nextTick(function() {
            this.initializeConditionsAndThings()
            this.getAgents()
            this.setAllTags();
            clearInterval(checkConnIntervalId)
          })
        }
        if (checkConnAttempts > 5) {
          console.log('...connection not open')
          clearInterval(checkConnIntervalId)
        }
      }, 1000);
  },
  mounted() {
    this.conditionsAvailables.push(this.availableReportList) // conditionsAvailables puede quedar desactualizado si solo se hace en este punto
    if (process.env.VUE_APP_SCHEDULED_REPORTS && process.env.VUE_APP_SCHEDULED_REPORTS.trim().length > 0) {
      this.scheduledReports = process.env.VUE_APP_SCHEDULED_REPORTS.split(',');
    }
    
    this.hasScheduledReportRole = store.getters.hasScheduledReportRole
    
    firebaseServices.logEvent(firebaseServices.analytics, 'btn_informe_nuevo')
    //this.checkThingsTelemetry()
    //this.initializeConditionsAndThings()
    //this.getAgents()
  },
  update() {}
}
</script>

<style lang="scss" scoped>
.createZoneBox {
  margin-left: -12em;
}
.createZoneBox-small {
  margin-left: -6em;
}
.orange--text {
  color: var(--orange) !important;
}
.dialog-attention {
  border: 2px solid var(--orange);
}
.container {
  margin: 0;
  padding-left: 30px;
}

.camposObligatorios {
  color: #d90077;
}
.progress {
  width: 100%;
}
.loading {
  background-color: #d90077;
  margin: 200;
}
.asterisc {
  color: #d90077;
}
.textColor {
  color: #0a2463;
}
.v-input {
  font-size: 16px;
}
.mapModalButtonBox {
  margin-left: 1.5em;
}
.align-date {
  margin-right: 16em;
}

.fix-input-align {
  position: relative;
  top: 3px
}
.warn-message {
  color:#bb3383;
  font-size: 14px;
  padding-top: 5px;
}
</style>
